var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileCart = function SvgMobileCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.667,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.943 13.47-.03-.123-1.561-6.265h19.592l-2.013 6.277a2.33 2.33 0 0 1-2.275 1.832h-11.41a2.33 2.33 0 0 1-2.303-1.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.333,
    d: "M28.37 19.192H14.335l-1.42-5.845L10.5 3.501H8.168m4.745 9.846a2.334 2.334 0 0 0 2.333 1.844h11.41a2.33 2.33 0 0 0 2.275-1.832l2.013-6.277H11.352zM15.11 25.606a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333M27.94 25.606a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333"
  })));
};
export default SvgMobileCart;